import React, { useState } from 'react';
import axios from 'axios';

const MarriageGarlandPage = ({ language }) => {
  
  const [bookingData, setBookingData] = useState({
    name: '',
    email: '',
    phone: '',
    groomName: '',
    brideName: '',
    weddingDate: '',
    weddingTime: '',
    deliveryAddress: '',
    city: '',
    state: '',
    pincode: '',
    garlandType: 'traditional',
    templeSelection: '',
    specialInstructions: '',
    paymentMethod: 'razorpay'
  });
  const [loading, setLoading] = useState(false);
  const API = process.env.REACT_APP_BACKEND_URL;

  const temples = [
    { name: 'Sri Parthasarathy Temple, Chennai', value: 'parthasarathy_chennai' },
    { name: 'Sri Ranganathaswamy Temple, Srirangam', value: 'ranganathar_srirangam' },
    { name: 'Sri Varadaraja Perumal Temple, Kanchipuram', value: 'varadaraja_kanchi' },
    { name: 'Sri Venkateswara Temple, Tirumala', value: 'venkateswara_tirumala' },
    { name: 'Sri Nataraja Temple, Chidambaram', value: 'nataraja_chidambaram' },
    { name: 'Sri Meenakshi Amman Temple, Madurai', value: 'meenakshi_madurai' },
    { name: 'Sri Ramanathaswamy Temple, Rameswaram', value: 'ramanathaswamy_rameswaram' },
    { name: 'Sri Kapaleeshwarar Temple, Chennai', value: 'kapaleeshwarar_chennai' },
    { name: 'Sri Thyagaraja Temple, Thiruvarur', value: 'thyagaraja_thiruvarur' },
    { name: 'Sri Brihadeeswara Temple, Thanjavur', value: 'brihadeeswara_thanjavur' }
  ];

  const garlandTypes = [
    { value: 'traditional', label_en: 'Traditional Lotus Garland', label_ta: 'பாரம்பரிய தாமரை மாலை', price: 5000 },
    { value: 'rose', label_en: 'Premium Rose Garland', label_ta: 'பிரீமியம் ரோஜா மாலை', price: 7500 },
    { value: 'jasmine', label_en: 'Fragrant Jasmine Garland', label_ta: 'நறுமண மல்லிகை மாலை', price: 6000 },
    { value: 'mixed', label_en: 'Mixed Flowers Garland', label_ta: 'கலப்பு பூ மாலை', price: 8000 },
    { value: 'premium', label_en: 'Premium Mixed with Gold Zari', label_ta: 'பிரீமியம் தங்க சரிகை மாலை', price: 15000 }
  ];

  const getSelectedPrice = () => {
    const selected = garlandTypes.find(g => g.value === bookingData.garlandType);
    return selected ? selected.price : 0;
  };

  const handleBooking = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const amount = getSelectedPrice();
      
      if (bookingData.paymentMethod === 'razorpay') {
        const orderRes = await axios.post(`${API}/payments/razorpay/create-order`, {
          amount: amount,
          currency: 'INR',
          receipt: `garland_${Date.now()}`,
          notes: { 
            service: 'marriage_garland',
            customer: bookingData.name,
            groom: bookingData.groomName,
            bride: bookingData.brideName,
            type: bookingData.garlandType,
            temple: bookingData.templeSelection
          }
        });

        const options = {
          key: orderRes.data.key_id,
          amount: orderRes.data.amount,
          currency: 'INR',
          name: 'Ahobilam.com',
          description: 'Marriage Garland Booking',
          order_id: orderRes.data.order_id,
          handler: async function (response) {
            // Save booking
            await axios.post(`${API}/services/bookings`, {
              service_type: 'marriage_garland',
              customer_details: bookingData,
              payment_id: response.razorpay_payment_id,
              payment_status: 'completed',
              amount: amount,
              booking_status: 'confirmed'
            });

            alert(language === 'en' 
              ? '🎉 Booking confirmed! We will contact you soon for delivery details.' 
              : '🎉 பதிவு உறுதிப்படுத்தப்பட்டது! விநியோக விவரங்களுக்கு விரைவில் உங்களை தொடர்பு கொள்வோம்.');
            
            // Reset form
            setBookingData({
              name: '', email: '', phone: '', groomName: '', brideName: '',
              weddingDate: '', weddingTime: '', deliveryAddress: '', city: '',
              state: '', pincode: '', garlandType: 'traditional',
              templeSelection: '', specialInstructions: '', paymentMethod: 'razorpay'
            });
          },
          prefill: {
            name: bookingData.name,
            email: bookingData.email,
            contact: bookingData.phone
          },
          theme: { color: '#16a34a' }
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      }
    } catch (error) {
      console.error('Booking error:', error);
      alert(language === 'en' ? 'Booking failed. Please try again.' : 'பதிவு தோல்வியடைந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-orange-50 to-green-50 py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-green-800 mb-4">
            💐 {language === 'en' ? 'Marriage Garland Service' : 'திருமண மாலை சேவை'}
          </h1>
          <p className="text-xl text-gray-700">
            {language === 'en'
              ? 'Traditional sacred garlands for your auspicious wedding ceremony'
              : 'உங்கள் மங்கள திருமண விழாவிற்கான பாரம்பரிய புனித மாலைகள்'}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Booking Form */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h2 className="text-3xl font-bold text-orange-600 mb-6">
                {language === 'en' ? 'Book Your Garland' : 'உங்கள் மாலையை பதிவு செய்யுங்கள்'}
              </h2>

              <form onSubmit={handleBooking} className="space-y-6">
                {/* Temple Selection */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Select Temple' : 'கோவிலை தேர்வு செய்யுங்கள்'}
                  </h3>
                  <select
                    value={bookingData.templeSelection}
                    onChange={(e) => setBookingData({...bookingData, templeSelection: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    required
                  >
                    <option value="">
                      {language === 'en' ? 'Please select a temple...' : 'தயவுசெய்து கோவிலை தேர்ந்தெடுக்கவும்...'}
                    </option>
                    {temples.map((temple) => (
                      <option key={temple.value} value={temple.value}>
                        {temple.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Contact Details */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Contact Information' : 'தொடர்பு தகவல்'}
                  </h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <input
                      type="text"
                      placeholder={language === 'en' ? 'Your Name' : 'உங்கள் பெயர்'}
                      value={bookingData.name}
                      onChange={(e) => setBookingData({...bookingData, name: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                    <input
                      type="email"
                      placeholder={language === 'en' ? 'Email' : 'மின்னஞ்சல்'}
                      value={bookingData.email}
                      onChange={(e) => setBookingData({...bookingData, email: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                  </div>
                  <input
                    type="tel"
                    placeholder={language === 'en' ? 'Phone Number' : 'தொலைபேசி எண்'}
                    value={bookingData.phone}
                    onChange={(e) => setBookingData({...bookingData, phone: e.target.value})}
                    className="w-full mt-4 px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                    required
                  />
                </div>
                

                {/* Wedding Details */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Wedding Details' : 'திருமண விவரங்கள்'}
                  </h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <input
                      type="text"
                      placeholder={language === 'en' ? "Groom's Name" : 'மாப்பிள்ளை பெயர்'}
                      value={bookingData.groomName}
                      onChange={(e) => setBookingData({...bookingData, groomName: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                    <input
                      type="text"
                      placeholder={language === 'en' ? "Bride's Name" : 'மணமகள் பெயர்'}
                      value={bookingData.brideName}
                      onChange={(e) => setBookingData({...bookingData, brideName: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                    <input
                      type="date"
                      value={bookingData.weddingDate}
                      onChange={(e) => setBookingData({...bookingData, weddingDate: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                    <input
                      type="time"
                      value={bookingData.weddingTime}
                      onChange={(e) => setBookingData({...bookingData, weddingTime: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                  </div>
                </div>
                

                {/* Garland Selection */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Select Garland Type' : 'மாலை வகையை தேர்வு செய்யுங்கள்'}
                  </h3>
                  <div className="space-y-3">
                    {garlandTypes.map(type => (
                      <label key={type.value} className="flex items-center justify-between p-4 border-2 rounded-lg cursor-pointer hover:bg-green-50 transition">
                        <div className="flex items-center">
                          <input
                            type="radio"
                            name="garlandType"
                            value={type.value}
                            checked={bookingData.garlandType === type.value}
                            onChange={(e) => setBookingData({...bookingData, garlandType: e.target.value})}
                            className="mr-3"
                          />
                          <span className="font-semibold">{language === 'en' ? type.label_en : type.label_ta}</span>
                        </div>
                        <span className="text-green-600 font-bold">₹{type.price.toLocaleString()}</span>
                      </label>
                    ))}
                  </div>
                </div>
                

                {/* Delivery Address */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Delivery Address' : 'விநியோக முகவரி'}
                  </h3>
                  <textarea
                    placeholder={language === 'en' ? 'Full Address' : 'முழு முகவரி'}
                    value={bookingData.deliveryAddress}
                    onChange={(e) => setBookingData({...bookingData, deliveryAddress: e.target.value})}
                    className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                    rows="3"
                    required
                  />
                  <div className="grid md:grid-cols-3 gap-4 mt-4">
                    <input
                      type="text"
                      placeholder={language === 'en' ? 'City' : 'நகரம்'}
                      value={bookingData.city}
                      onChange={(e) => setBookingData({...bookingData, city: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                    <input
                      type="text"
                      placeholder={language === 'en' ? 'State' : 'மாநிலம்'}
                      value={bookingData.state}
                      onChange={(e) => setBookingData({...bookingData, state: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                    <input
                      type="text"
                      placeholder={language === 'en' ? 'Pincode' : 'பின் குறியீடு'}
                      value={bookingData.pincode}
                      onChange={(e) => setBookingData({...bookingData, pincode: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                  </div>
                </div>
                

                {/* Special Instructions */}
                <div>
                  <label className="block text-lg font-semibold mb-2">
                    {language === 'en' ? 'Special Instructions (Optional)' : 'சிறப்பு அறிவுறுத்தல்கள் (விருப்பமானது)'}
                  </label>
                  <textarea
                    value={bookingData.specialInstructions}
                    onChange={(e) => setBookingData({...bookingData, specialInstructions: e.target.value})}
                    className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                    rows="3"
                    placeholder={language === 'en' ? 'Any specific requirements or preferences...' : 'ஏதேனும் குறிப்பிட்ட தேவைகள் அல்லது விருப்பத்தேர்வுகள்...'}
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-orange-600 to-green-600 text-white py-4 rounded-lg hover:from-orange-700 hover:to-green-700 font-bold text-xl disabled:opacity-50 transition"
                >
                  {loading ? 'Processing...' : `${language === 'en' ? 'Book & Pay' : 'பதிவு செய்து செலுத்துங்கள்'} ₹${getSelectedPrice().toLocaleString()}`}
                </button>
              </form>
            </div>
          </div>

          {/* Info Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-xl p-6 sticky top-8">
              <h3 className="text-2xl font-bold text-green-800 mb-4">
                {language === 'en' ? 'Service Includes' : 'சேவையில் அடங்கியவை'}
              </h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">✓</span>
                  <span>{language === 'en' ? 'Fresh flowers delivered on time' : 'புதிய பூக்கள் சரியான நேரத்தில் வழங்கப்படும்'}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">✓</span>
                  <span>{language === 'en' ? 'Traditional design as per customs' : 'பழக்கவழக்கங்களின்படி பாரம்பரிய வடிவமைப்பு'}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">✓</span>
                  <span>{language === 'en' ? 'Mantras chanted during preparation' : 'தயாரிப்பின் போது மந்திரங்கள் உச்சரிக்கப்படும்'}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">✓</span>
                  <span>{language === 'en' ? 'Free consultation on auspicious timing' : 'நல்ல நேரம் குறித்து இலவச ஆலோசனை'}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">✓</span>
                  <span>{language === 'en' ? 'Secure packaging for transport' : 'போக்குவரத்துக்கு பாதுகாப்பான பேக்கிங்'}</span>
                </li>
              </ul>

              <div className="mt-6 p-4 bg-orange-50 rounded-lg border border-orange-200">
                <p className="text-sm text-gray-700">
                  {language === 'en'
                    ? '📞 Need help? Contact us at +91-8610736302 or email svknvs@gmail.com'
                    : '📞 உதவி தேவையா? +91-8610736302 அல்லது svknvs@gmail.com என்ற முகவரியில் எங்களை தொடர்பு கொள்ளுங்கள்'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarriageGarlandPage;
